import HomeSEO from './components/HomeSEO';
import NavBar from './components/NavBar';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import HowItWorksSection from './components/HowItWorksSection';
import FeaturesSection from './components/FeaturesSection';
import DialBackSpotlight from './components/DialBackSpotlight';
import QuoteBreak from './components/QuoteBreak';
import WaitlistSection from './components/WaitlistSection';
import FooterSection from './components/FooterSection';

export default function Home() {
  return (
    <div className="bg-[#060606] text-[#faf9f7]">
      <HomeSEO />
      <NavBar />
      <HeroSection />
      <ProblemSection />
      <HowItWorksSection />
      <FeaturesSection />
      <DialBackSpotlight />
      <QuoteBreak />
      <WaitlistSection />
      <FooterSection />
    </div>
  );
}
